import React, { ReactNode } from 'react'

import { mapDispatchToProps } from './components/ErrorContainer'

export enum ErrorType {
	HARD,
	SOFT,
}

export type ErrorContainerProps = Readonly<
	ReturnType<typeof mapDispatchToProps> & {
		children: React.ReactNode
	}
>

export type ErrorContainerState = {
	body: string | null
	error: Error | null
	open: boolean
	response?: Response
	timestamp: Date | null
	type: ErrorType
}

export interface ConfirmationOptions {
	autoStart?: boolean
	catchOnCancel?: boolean
	description: string | React.ReactNode
	hasError?: boolean
	isAsync?: boolean
	isCanceled?: boolean
	onDownload?: () => Promise<void> | void
	preserveProcessingState?: boolean
	progress?: number
	showDownloadButton?: boolean
	taskState?: 'NEW' | 'RUNNING' | 'ERROR' | 'FINISHED' | 'CANCELLED'
	title: string
}

export interface ConfirmationDialogProps extends ConfirmationOptions {
	footer: React.ReactNode
	onClose: () => void
	onSubmit: (cancel?: boolean) => void
	open: boolean
}

export type AppProps = {
	token?: string
}
export interface ConfirmationServiceProps {
	children: ReactNode
}
